import { intervalToDuration } from 'date-fns';

class CountdownBar extends HTMLElement {
  connectedCallback() {
    this.end = new Date(this.dataset.endDate);
    this.closeButton = this.querySelector('.countdown-bar__close');

    this.elements = {
      days: this.querySelector('[data-countdown-days-time]'),
      hours: this.querySelector('[data-countdown-hours-time]'),
      minutes: this.querySelector('[data-countdown-minutes-time]'),
      seconds: this.querySelector('[data-countdown-seconds-time]'),
    }

    setInterval(() => {
      this.setCountdown(this.getDuration());
    }, 1000);

    this.closeButton.addEventListener('click', () => this.closeBar());
  }

  disconnectedCallback() {
    // Trigger a height change event on the sticky header elements
    const stickyHeaderElements = document.querySelector('.sticky-header-elements');
    stickyHeaderElements.setAttribute('data-height-changed', true);
  }

  /**
   * Get the duration between the current date and the end date
   */
  getDuration() {
    const start  = Date.now();
    const {
      years = 0,
      months = 0,
      weeks = 0,
      days = 0,
      hours = 0,
      minutes = 0,
      seconds = 0
    } = intervalToDuration({ start, end: this.end });

    // Calculate the total number of days based on the years, months, weeks, and days
    const formattedDays = days + weeks * 7 + months * 30 + years * 365;

    return { days: formattedDays, hours, minutes, seconds };
  }

  /**
   * Set the countdown values in the DOM
   * @param {Object} countdown - The countdown values
   * @param {number} countdown.days - The number of days
   * @param {number} countdown.hours - The number of hours
   * @param {number} countdown.minutes - The number of minutes
   * @param {number} countdown.seconds - The number of seconds
   */
  setCountdown({ days, hours, minutes, seconds }) {
    this.elements.days.textContent = days;
    this.elements.hours.textContent = hours;
    this.elements.minutes.textContent = minutes;
    this.elements.seconds.textContent = seconds
  }

  /**
   * Close the countdown bar
   */
  closeBar() {
    this.closest('section').remove();
    this.updateCart();
  }

  async updateCart() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        ...fetchConfig(),
        body: JSON.stringify({
          attributes: {
            'countdown_bar_closed_on': Math.floor(Date.now() / 1000)
          }
        }),
      });
    } catch (error) {
      console.log(error);
    }
  }
}

customElements.define('countdown-bar', CountdownBar);
